import React, { useMemo } from 'react';
import MirsTable from 'components/general/table/Table.js';
import { findArray } from 'helpers/utils';
import { ColumnGender } from "components/common/TableColumns"
import { NocMemo as Noc } from 'components/presentation/Noc';
import Competitor from 'components/presentation/Competitor';
import { useViewport } from 'components/general/useViewPort'
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";
import Referees from 'components/general/Referees'
import Label from "components/general/Label"

const getConfigForCoaches = () => {
  let config = {
      source: 'coach',     
      nationality: true,
      avoidDuplicates: true,
      hideNoc: true,
      filter: ['COACH', 'AST_COA']
  }
  return config

}

function getStatColumn({
  id = '',
  header =  '',
  code =  ''
}){
  return (
    {
      id: id,
      Header: header,
      headerClassName: "text-end",
      className: 'text-end w-5',
      Cell: (props) => {
        const row = props.cell.row.original
        const val = findArray(row.statsItems, { code: [code] }).value
        return (
          row.bib ? val : <span className="fw-bold">{val}</span>
        )
      }
    }
  )
}

function WruPlayerStats({ data, team }) {
  const { mirs_rsc } = useUrlFriendlyToParameters()
  let athletes = findArray(data?.results?.items, { startSortOrder: [team] })?.teamAthletes;
  // Add teamstats to athletes array
  let item = data?.results?.items.find(i => i.startSortOrder === team)
  athletes.push(item)

  let competitorNoc = findArray(data?.results?.items, { startSortOrder: [team] })?.participant?.organisation?.code;
  let competitorCode = findArray(data?.results?.items, { startSortOrder: [team] })?.participant?.code;
  let participant = findArray(data?.results?.items, { startSortOrder: [team] })?.participant;

  const tableColumns = useMemo(() =>
    [
      {
          Header: <Label data='HeaderNumber' />,
          accessor: (props) => (
            props?.bib || 999
          ),
          className : 'text-end',
          headerClassName : 'text-end w-5 text-nowrap',
          disableSortBy: true,
          id: 'Bib',
          Cell: (props) => {
              const row = props.cell.row.original
              return row.bib || ''
          }
      },
      {
        Header: <Label data='HeaderName' />,
        accessor: 'athlete.familyName',
        id: 'Name',
        className : 'text-start',
        headerClassName: 'text-start',
        disableSortBy: true,
        Cell: (props) => {
          return (
              props.cell.row.original.teamAthletes 
                ? <div className="w-100 text-end fw-bold"><Label data='HeaderTotals' /></div>
                :
                <>
                    <Competitor
                        {...props.cell.row.original?.athlete}

                        eventUnitEntries={props.cell.row.original?.eventUnitEntries}
                        hidePicture={true}
                        showCaptain={false}
                        showCaptainAbbr={false}
                        medicalClass={props.cell.row.original?.medicalClass}
                        showSuspendedCode={false}
                        showStarter={false}
                        hideNoc={false}
                    />
                </>
          );
        }
      },
      ColumnGender({}),
      getStatColumn({id: 'MinsPlayed', header: 'Min', code:'MINS'}),
      getStatColumn({id: 'tries', header: 'Tries', code:'TRY'}),
      getStatColumn({id: 'offensivefouls', header: 'OF', code:'OF'}),
      getStatColumn({id: 'deffensivefouls', header: 'DF', code:'DF'}),
      getStatColumn({id: 'turnovers', header: 'TO', code:'TO'}),
      getStatColumn({id: 'steals', header: 'ST', code:'ST'}),
      getStatColumn({id: 'flagrantfouls', header: 'FF', code:'FF'}),
      getStatColumn({id: 'doubleflagrantfouls', header: '2FF=DQF', code:'FF2'}),
      getStatColumn({id: 'disqualifying', header: 'DQF', code:'DQF'}),
      getStatColumn({id: 'penalties', header: 'PT', code:'PT'})
    ], []
  )

  const tableColumnsSM = useMemo(() =>
    [
      {
        Header: '',
        accessor: (props) => (
          props?.bib || 999
        ),
        className : 'text-end',
        headerClassName : 'text-end w-5 text-nowrap',
        disableSortBy: true,
        id: 'Bib',
        Cell: (props) => {
            return ''
        }
      },      
      {
        Header: <Label data='HeaderName' />,
        accessor: 'athlete.familyName',
        id: 'Name',
        className : 'text-start',
        headerClassName: 'text-start',
        disableSortBy: true,
        Cell: (props) => {
          return (
              props.cell.row.original.teamAthletes 
                ? <div className="w-100 text-end fw-bold"><Label data='HeaderTotals' /></div>
                :
                <>
                    <Competitor
                        {...props.cell.row.original?.athlete}

                        eventUnitEntries={props.cell.row.original?.eventUnitEntries}
                        hidePicture={true}
                        showCaptain={false}
                        showCaptainAbbr={false}
                        medicalClass={props.cell.row.original?.medicalClass}
                        showSuspendedCode={false}
                        showStarter={false}
                        hideNoc={false}
                    />
                </>
          );
        }
      },
      getStatColumn({id: 'MinsPlayed', header: 'Min', code:'MINS'}),
      getStatColumn({id: 'tries', header: 'Tries', code:'TRY'}),
      getStatColumn({id: 'offensivefouls', header: 'OF', code:'OF'}),
      getStatColumn({id: 'deffensivefouls', header: 'DF', code:'DF'}),
      getStatColumn({id: 'turnovers', header: 'TO', code:'TO'}),
      getStatColumn({id: 'steals', header: 'ST', code:'ST'}),
      getStatColumn({id: 'flagrantfouls', header: 'FF', code:'FF'}),
      getStatColumn({id: 'doubleflagrantfouls', header: '2FF=DQF', code:'FF2'}),
      getStatColumn({id: 'disqualifying', header: 'DQF', code:'DQF'}),
      getStatColumn({id: 'penalties', header: 'PT', code:'PT'})

    ], []
  )
  let _caption = <CaptionTeam competitorNoc={competitorNoc} participant={participant} />
  const { breakPoint } = useViewport();
  const coachesConf = getConfigForCoaches();
  const teamData = data?.results?.items?.find(item => item.startSortOrder === team)
  let columns = (breakPoint === "sm" || breakPoint === "xs") ? tableColumnsSM : tableColumns

  return (
    <>
      <MirsTable
        id={`mirs-table-player-statistics-${team + '-' + mirs_rsc}-${competitorCode}`}
        caption={_caption}
        data={athletes}
        columns={columns}
        keyRow={"athlete-code"}
        initialSortBy={[{ id: 'Bib', desc: false }]}
        colsExtendedVisible={(breakPoint === "sm" || breakPoint === "xs") ? '7' : '7'}
        showNavExtendedData={true}
        colIndex={1}
      />
      <Referees data={teamData?.teamCoaches} config={coachesConf} homeAway={team === 1 ? "H" : "A"} noc={teamData?.participant?.organisation?.code} />
    </>
  );
}

export default WruPlayerStats;

function CaptionTeam({ participant }) {
  return (
    <div className='d-flex align-items-center'>
      <div className='d-none d-md-block me-1'>
        <Noc {...participant?.organisation} />
      </div>
      <strong>
        <Competitor hidePicture={true} {...participant} />
      </strong>
    </div >
  )
}

function PlayerStatsType({ value, attempt }) {
  if (value !== undefined) {
    return (
      <>
        {value}/{attempt}
      </>
    )
  }
}